import { render } from "./MultiEditTag.vue?vue&type=template&id=f8220bec"
import script from "./MultiEditTag.vue?vue&type=script&lang=js"
export * from "./MultiEditTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__